import React from 'react';

interface Props {
  header?: JSX.Element;
  content: JSX.Element;
  footer: JSX.Element;
}

const RestrictedLayout = ({ header, content, footer }: Props) => (
  <div>
    {header}
    {content}
    {footer}
  </div>
);

export default RestrictedLayout;
